import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import databaseService from '../services/databaseService';
import RichTextEditor from './RichTextEditor';
import { isAuthenticated } from '../services/authService';

const EditArchive = () => {
  const { archiveId } = useParams();
  const navigate = useNavigate();
  const [archive, setArchive] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/auth/login');
      return;
    }

    loadArchive();
  }, [archiveId, navigate]);

  const loadArchive = async () => {
    try {
      await databaseService.init();
      const archiveData = await databaseService.getArchivePost(parseInt(archiveId));
      
      if (archiveData) {
        setArchive({
          ...archiveData,
          content: archiveData.content || '',
          title: archiveData.title || ''
        });
      } else {
        setError('Archive post not found');
      }
    } catch (error) {
      console.error('Failed to load archive:', error);
      setError('Failed to load archive post');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (archiveData) => {
    try {
      await databaseService.updateArchivePost(archive.id, {
        ...archive,
        ...archiveData,
        updated_at: new Date().toISOString()
      });
      
      navigate('/admin');
    } catch (error) {
      console.error('Failed to save archive:', error);
      alert('Failed to save archive post. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  if (loading) {
    return <div className="admin-container">Loading archive post...</div>;
  }

  if (error) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  if (!archive) {
    return (
      <div className="admin-container">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Archive Post Not Found</h2>
          <p>The archive post you're looking for doesn't exist.</p>
          <button onClick={() => navigate('/admin')} className="btn btn-primary">
            Back to Admin
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <RichTextEditor
        initialContent={archive.content}
        title={archive.title}
        onSave={handleSave}
        onCancel={handleCancel}
        isEditing={true}
      />
    </div>
  );
};

export default EditArchive;
